import * as React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import * as d from "../../../reducers/domainReducer";
import * as types from "../../../constants/actionTypes";

class Footer extends React.Component {
    constructor(props) {
        super(props); 
        this.onVideoTipsClicked = this.onVideoTipsClicked.bind(this);
    }  

    onVideoTipsClicked() {
        const { collapseMenu } = this.props;
        if (collapseMenu)
            collapseMenu();
    }

    render() {
        const { bundle, isProxyUser, currentPharmacyUser, applicationVersion, helpDeskNumber, helpDeskEmail, helpDeskEmailText, showAssistanceLink, fixBottom, currentYear, isMenuCollapsed } = this.props;
        let isClientSide = typeof window !== 'undefined';
        let showFooterLinks = bundle === "mybswhealth" || (bundle === "pharmacy" && !currentPharmacyUser);                 
        return (
            <div className={`container-fluid footer-container footer-loggedin ${fixBottom}`}>
                <div className="row">
                    <div className="col-12">
                        <div className="row">
                            {showAssistanceLink && <div className="col-12 col-sm-6 footer__links">
                                <p>If you need assistance, please call the help desk at <a href={"tel:" + helpDeskNumber} className="phone-link">{helpDeskNumber}</a>.</p>
                            </div>}
                            {isClientSide && 
                             <div className="col-12 col-md-6 footer__links">
                                <div className="footer__help-links">
                                    <div className="help-title">Need Help?</div>
                                    <div className="help-email"><a href={"tel:" + helpDeskNumber}><span className="icon-phone" /> {helpDeskNumber}</a></div>
                                    <div className="help-tips"><Link to={{ pathname: "/videovisittips" }} onClick={this.onVideoTipsClicked}><span className="icon-question" /> Helpful Video Tips</Link></div>
                                </div>
                                {showFooterLinks && 
                                    <React.Fragment>
                                        <Link to={{ pathname: "/terms" }}>
                                            Terms of Use
                                        </Link>
                                        <Link to={{ pathname: "/privacy" }}>
                                            Privacy Policy
                                        </Link>
                                        <Link to={{ pathname: "/disclosures" }}>
                                            Disclosure Statements
                                        </Link>
                                        <Link to={{ pathname: "/faq" }}>
                                            FAQ
                                        </Link>  
                                        <Link to={{ pathname: "/customerservice" }}>
                                            Customer Service
                                        </Link>  
                                    </React.Fragment>
                                  }
                            </div>
                            }
                            <div className="col-12 col-md-6 footer__copyright">
                                <Link to={{ pathname: "/providervideovisit/lobby" }}>Test Room</Link>
                                <div className="copyright">© {currentYear} All Rights Reserved</div>
                                <div className="mychart-copyright">Version: {applicationVersion}</div>
                                {/*<div className="mychart-copyright">MyChart® Epic System Corporation</div>*/}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        helpDeskNumber: state.session.serverData.helpDeskNumber,       
        helpDeskEmail: state.session.serverData ? state.session.serverData.helpDeskEmail : "",
        helpDeskEmailText: state.session.serverData ? state.session.serverData.helpDeskEmailText : "",
        //thrive: state.header.thrive, 
        bundle: state.session.serverData ? state.session.serverData.bundle : "mybswhealth",  // we'll default with rendering for mybswhealth
        isProxyUser: state.domain.ip,
        currentYear: state.session.serverData && state.session.serverData.currentYear ? state.session.serverData.currentYear : "2020",
        currentPharmacyUser: d.hydratePharmacyUser(state.domain.cpu),
        applicationVersion: state.session.serverData ? state.session.serverData.applicationVersion : "1.0.0.0",  // we'll default with rendering for mybswhealth
        isMenuCollapsed: state.common.showCollapsedMenu
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        collapseMenu: () => dispatch({ type: types.COLLAPSE_MENU, showCollapsedMenu: true })
    };
};


export default connect( mapStateToProps, mapDispatchToProps)(Footer) ;